import { render, staticRenderFns } from "./ResumeEdit.vue?vue&type=template&id=efdbf3f4&scoped=true&"
import script from "../../../services/applicant/resume/resume-edit.js?vue&type=script&lang=js&"
export * from "../../../services/applicant/resume/resume-edit.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/resume_detail.css?vue&type=style&index=0&id=efdbf3f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdbf3f4",
  null
  
)

export default component.exports